"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Pill.pc.css");
const Pill = ({ bold, transparent, positive, negative, notice, info, secondary, title, style, className, children, testId, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_a81ed89d', '_a3f9ad90', '_pub-a3f9ad90', '_pub-3c25d522', '_a3f9ad90_ds-pill', '_pub-a3f9ad90_ds-pill', '_pub-3c25d522_ds-pill', 'ds-pill', {
            '_a3f9ad90_bold _pub-a3f9ad90_bold _pub-3c25d522_bold bold': bold,
            '_a3f9ad90_transparent _pub-a3f9ad90_transparent _pub-3c25d522_transparent transparent': transparent,
            '_a3f9ad90_positive _pub-a3f9ad90_positive _pub-3c25d522_positive positive': positive,
            '_a3f9ad90_negative _pub-a3f9ad90_negative _pub-3c25d522_negative negative': negative,
            '_a3f9ad90_notice _pub-a3f9ad90_notice _pub-3c25d522_notice notice': notice,
            '_a3f9ad90_info _pub-a3f9ad90_info _pub-3c25d522_info info': info,
            '_a3f9ad90_secondary _pub-a3f9ad90_secondary _pub-3c25d522_secondary secondary': secondary,
        }, className), "data-pc-label": "Pill", "data-testid": testId, title: title, style: style }, children));
};
exports.Pill = Pill;
//# sourceMappingURL=Pill.js.map